import { API_URLs } from "../../../../utilities/API_URLs"
import iAxios from "../../../../utilities/axios/axios-setup"
import { Http } from "../../../../utilities/axios/http"
import { UserPageState, NewUserRequest } from "./_model"
// import { NewRoleData, UserRolePageState } from "./_model"

export const postNewUser = (data: NewUserRequest) => {
  return iAxios.post(API_URLs.settings.users.postUser, data)
  .then(r => {
    return r.data
  })
  .catch(e => {
    return null
  })
}

export const getUserList = (pageState: UserPageState) => {
  const obj: any = {...pageState, order: null}
  Object.keys(pageState).forEach((key: any) => {
    if (key === 'order') {
      console.log('The order key ')
      obj['order[' + (pageState?.order?.dataKey ?? '') + ']'] = pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString()
    }
    
  })
  delete obj['order']
  console.log('List page state : ', obj)
  return iAxios.get(API_URLs.settings.users.getUsers + '?' + new URLSearchParams(obj) )
  .then(r => {
    return r?.data
  })
  .catch(e => {
    return null
  })
}

export const getUserById = (id: string) => {
  return iAxios.get(API_URLs.settings.users.getUserById?.replace('{id}', id))
  .then(r => {
    return r.data
  })
  .catch(e => {
    return null
  })
}

export const deleteUserById = (id: string) => {
  return iAxios.delete(API_URLs.settings.users.deleteUserById?.replace('{id}', id))
  .then(r => {
    return {success: true, data: r.data}
  })
  .catch(e => {
    return null
  })
}

export const patchUserById = (id: string, data: NewUserRequest) => {
  return iAxios.patch(API_URLs.settings.users.patchUserById?.replace('{id}', id), {...data, id}, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    }
  })
  .then(r => {
    return r.data
  })
  .catch(e => {
    return null
  })
}

export class UserService {
  static postUser = async (data: any) => {
    try {
      return await Http.post(API_URLs.settings.users.usersUrl, data);
    } catch (error) {
      return error
    }
  }

  static getUser = async (id: number) => {
    try {
      return await Http.get(`${API_URLs.settings.users.usersUrl}/${id}`);
    } catch (error) {
      return error
    }
  }

  static getUserList = async (params?: any) => {
    try {
      return await Http.get(API_URLs.settings.users.usersUrl, params)
    } catch (error) {
      return error;
    }
  }

  static updateUser = async (data: any) => {
    try {
      return await Http.patch(API_URLs.settings.users.usersUrl, data);
    } catch (error) {
      return error;
    }
  }

  static deleteUser = async (id: number) => {
    try {
      return await Http.delete(`${API_URLs.settings.users.usersUrl}/${id}`);
    } catch (error) {
      return error;
    }
  }
}